export default __webpack_public_path__ + "static/media/planet1.979145c9.png";